(function() {
    var waitForForm = setInterval(function() {
        var formEmbed = document.querySelector('shopify-forms-embed');

        if (formEmbed && formEmbed.shadowRoot) {
            
            // 1. INJECT CSS (Layout & Grid)
            var style = document.createElement('style');
            style.textContent = `
                 /* --- LAYOUT FIXES --- */
                :host {
                    --container-max-w: 100% !important;
                    --inline-container-max-width: 100% !important;
                    --app-embed-width: 100% !important; 
                }

                [data-sizing="form-wrapper"] {
                    width: 100% !important;
                    max-width: 100% !important;
                    margin:0!important;
                }

                /* --- 2-COLUMN GRID --- */
                [data-testid="form"] {
                    display: grid !important;
                    grid-template-columns: 1fr 1fr; 
                    gap: 15px; 
                    align-items: start; /* Prevents stretching if one col is taller */
                }

                /* Full width elements */
                [data-testid="form"] > div:has(textarea),
                [data-testid="btn-form-submit"],
                .full-width-field {
                    grid-template-columns: 1fr 1fr; 
                    gap: 0; 
                }

                /* --- ERROR HANDLING FIX --- */
                /* HIDE the original error message so it doesn't break the grid */
                [data-testid="form"] > output {
                    display: none !important; 
                }

                /* Style our custom cloned error */
                .custom-error-msg {
                    display: block;
                    color: var(--form-error-color, #e02229);
                    font-size: 13px;
                    margin-top: 5px;
                    line-height: 1.4;
                }

                /* Make sure the container stacks the input and error vertically */
                div[class*="_formFieldContainer"] {
                    display: flex !important;
                    flex-direction: column !important;
                }

                /* Mobile Support */
                @media (max-width: 768px) {
                    [data-testid="form"] { grid-template-columns: 1fr !important; }
                    [data-testid="form"] > div, 
                    [data-testid="btn-form-submit"] { grid-column: span 1 !important; }
                }
            `;

            formEmbed.shadowRoot.appendChild(style);

            // 2. JS LOGIC: Update Labels & Handle Custom Errors
            setInterval(function() {
                var root = formEmbed.shadowRoot;

                // --- A. CHANGE WHATSAPP LABEL ---
                // We target the label specifically for the whatsapp field
                var waLabel = root.querySelector('label[for="custom#whatsapp_number"]');
                // if (waLabel && waLabel.textContent !== "WhatsApp/Phone") {
                //     waLabel.textContent = "WhatsApp/Phone";
                // }

                // --- B. HANDLE ERRORS ---
                var containers = root.querySelectorAll('div[class*="_formFieldContainer"]');
                
                containers.forEach(function(container) {
                    // 1. Identify the field inside this container
                    var field = container.querySelector('input, textarea');
                    var fieldId = field ? field.id : '';
                    var fieldName = field ? field.name : '';

                    // 2. Check if an error exists next to this container
                    var nextEl = container.nextElementSibling;
                    var hasError = nextEl && nextEl.tagName === 'OUTPUT';

                    // 3. Check/Create our custom error clone
                    var existingClone = container.querySelector('.custom-error-msg');

                    if (hasError) {
                        if (!existingClone) {
                            existingClone = document.createElement('div');
                            existingClone.className = 'custom-error-msg';
                            container.appendChild(existingClone);
                        }
                        console.log(fieldName);
                        

                        // --- C. SET CUSTOM ERROR MESSAGES ---
                        var errorText = nextEl.textContent;
                        if (fieldId === 'custom#whatsapp_number') {
                            errorText = "WhatsApp/Phone is required"; 
                        } else if (fieldName === 'custom#products_quantity') {
                            errorText = "Products & Quantity is required";
                        } else if (fieldName === 'custom#notes_specs') {
                            errorText = "Notes/ Specs is required";
                        } else if (fieldId === 'first_name') {
                            errorText = "Name is required";
                        }
                        existingClone.textContent = errorText;
                    } else {
                        if (existingClone) {
                            existingClone.remove();
                        }
                    }
                });
            }, 200); 

            clearInterval(waitForForm);
        }
    }, 500); 
})();